import React from "react";
import MobileRecording from "./mobileRecording";
import {injectRemoveTableHeader} from "../../../utils/mobileUtils";
import MobileRecordingHeader from "./mobileRecordingHeader";
import MobileContinueButton from "../button/mobileContinueButton";
import MobileCancelButton from "../button/mobileCancelButton";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

class MobileRecordingNumberBlock extends MobileRecording {
    constructor(props) {
        super();
    }

    render = () => {
        const {
            currentFlowChart,
            currentRecordingFlowChart,
            recordData
        } = this.props;

        let data = [];
        let columns = [];

        const ReactTableFixedColumns = withFixedColumns(ReactTable);

        const continueButtonDisabled = this.isContinueButtonDisabled(
            currentRecordingFlowChart,
            recordData
        );
        const selectionDisabled = this.isSelectionDisabled(
            currentRecordingFlowChart,
            recordData
        );

        columns = [
            {
                Header: (
                    <MobileRecordingHeader
                        title={currentFlowChart.title.text}
                        subTitle={
                            currentRecordingFlowChart.title.text +
                            ": " +
                            recordData.fields[
                                `${currentRecordingFlowChart.tableField}Display`
                                ]
                        }
                    />
                ),
                fixed: "left",
                columns: [
                    {
                        Header: "remove",
                        // width: 100,
                        Cell: ({original}) => (
                            <button
                                className="btn btn-secondary btn-lg btn-block"
                                value={original.id}
                                onClick={() => {
                                    this.onChange(original.text1);
                                }}
                                disabled={selectionDisabled && !original.text1AlwaysEnabled}
                            >
                                {original.text1}
                            </button>
                        ),
                        Footer: () => (
                            <MobileContinueButton
                                onClick={() => {
                                    this.onFieldContinue();
                                }}
                                disabled={continueButtonDisabled}
                                title={{text: "Weiter"}}
                            />
                        )
                    },
                    {
                        Header: "remove",
                        // width: 100,
                        Cell: ({original}) => (
                            <button
                                className="btn btn-secondary btn-lg btn-block"
                                value={original.id}
                                onClick={() => {
                                    this.onChange(original.text2);
                                }}
                                disabled={selectionDisabled && !original.text2AlwaysEnabled}
                            >
                                {original.text2}
                            </button>
                        )
                    },
                    {
                        Header: "remove",
                        // width: 100,
                        Cell: ({original}) => (
                            <button
                                className="btn btn-secondary btn-lg btn-block"
                                value={original.id}
                                onClick={() => {
                                    this.onChange(original.text3);
                                }}
                                disabled={selectionDisabled && !original.text3AlwaysEnabled}
                            >
                                {original.text3}
                            </button>
                        ),
                        Footer: () => (
                            <div className="text-right">
                                <MobileCancelButton
                                    onClick={() => {
                                        this.onFieldCancel();
                                    }}
                                    title={{text: "Abbr."}}
                                />
                            </div>
                        )
                    }
                ]
            }
        ];
        data.push({id: 0, text1: "1", text2: "2", text3: "3"});
        data.push({id: 1, text1: "4", text2: "5", text3: "6"});
        data.push({id: 2, text1: "7", text2: "8", text3: "9"});
        data.push({
            id: 3,
            text1: "CLR",
            text1AlwaysEnabled: true,
            text2: "0",
            text3: "BS",
            text3AlwaysEnabled: true
        });

        return (
            <React.Fragment>
                <ReactTableFixedColumns
                    columns={columns}
                    data={data}
                    defaultPageSize={data.length}
                    showPagination={false}
                    getTheadThProps={injectRemoveTableHeader}
                    //style={{ height: window.innerHeight }}
                />
            </React.Fragment>
        );
    }
}

export default MobileRecordingNumberBlock;
